import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import { makeStyles } from "@material-ui/core/styles";

import Navbar from "../components/Navbars/Navbar.js";
import Footer from "../components/Footer/Footer.js";
import Sidebar from "../components/Sidebar/Sidebar.js";

import routes from "routes.js";
import styles from "../assets/jss/material-dashboard-react/layouts/adminStyle.js";
import bgImage from "../assets/img/sidebar-2.jpg";
import logo from "../assets/img/reactlogo1.png";

// Loading
import { LoadingProvider } from "../contexts/LoadingContext.js";
import LoadingOverlay from "../components/LoadingOverlay/LoadingOverlay";
import { ADMINISTRACION, ADMINISTRADOR, DIRECTOR, GENERAL } from "../core/utils/roles.constants";

let ps;

const restrictedPathsByRole = {
  "/configuracion": [ADMINISTRADOR, DIRECTOR, ADMINISTRACION], // solo estos roles
};

const blockedPathsByRole = {
  "/rendiciones": [GENERAL], // estos roles NO pueden entrar
  "/proveedores": [GENERAL], // estos roles NO pueden entrar
};

const canAccessRoute = (route, user) => {
  if (!user) return route.path === "/inicio";

  const path = route.path;
  const role = user.es_admin;

  // Restricción por permitidos
  const allowedRoles = restrictedPathsByRole[path];
  if (allowedRoles && !allowedRoles.includes(role)) {
    return false;
  }

  // Restricción por bloqueados
  const blockedRoles = blockedPathsByRole[path];
  if (blockedRoles?.includes(role)) {
    return false;
  }

  return true;
};

const getAllowedAdminPathsByRole = (user) => {
  return routes
    .filter((route) => route.layout === "/admin")
    .filter((route) => canAccessRoute(route, user))
    .map((route) => route.path);
};

const getUserFromStorage = () => {
  try {
    const raw = localStorage.getItem("userData");
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const useStyles = makeStyles(styles);

export default function Admin({ ...rest }) {
  const classes = useStyles();
  const mainPanel = React.useRef(null);

  const [image] = React.useState(bgImage);
  const [color] = React.useState("blue");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [showSidebar, setShowSidebar] = React.useState(true);

  const user = getUserFromStorage();
  const allowedPaths = getAllowedAdminPathsByRole(user);
  const filteredRoutes = routes.filter(
    (route) => route.layout === "/admin" && allowedPaths.includes(route.path)
  );

  const switchRoutes = (
    <Switch>
      {filteredRoutes.map((prop, key) => (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      ))}
      <Route
        path="/uploads/:filename"
        render={({ match }) => {
          const fileUrl = `/uploads/${match.params.filename}`;
          window.open(fileUrl, "_blank");
          return null;
        }}
      />
      <Redirect from="/admin" to="/admin/inicio" />
    </Switch>
  );

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    setShowSidebar((prev) => !prev);
  };

  const getRoute = () => window.location.pathname !== "/admin/maps";

  const resizeFunction = () => {
    if (window.innerWidth >= 960) setMobileOpen(false);
  };

  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) ps.destroy();
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);

  return (
    <LoadingProvider>
      <div className={classes.wrapper}>
        {showSidebar && (
          <Sidebar
            routes={filteredRoutes}
            logoText={"IIM"}
            logo={logo}
            image={image}
            handleDrawerToggle={handleDrawerToggle}
            open={mobileOpen}
            color={color}
            showSidebar={showSidebar}
            {...rest}
          />
        )}
        <div
          className={classes.mainPanel}
          ref={mainPanel}
          style={{
            width: showSidebar ? `calc(100% - 260px)` : "100%",
            marginLeft: showSidebar ? 260 : 0,
          }}
        >
          <Navbar
            routes={filteredRoutes}
            handleDrawerToggle={handleDrawerToggle}
            showSidebar={showSidebar}
            setShowSidebar={setShowSidebar}
            {...rest}
          />

          {getRoute() ? (
            <div className={classes.content}>
              <div className={classes.container}>{switchRoutes}</div>
            </div>
          ) : (
            <div className={classes.map}>{switchRoutes}</div>
          )}
          {getRoute() && <Footer />}

          {/* Overlay global de carga */}
          <LoadingOverlay />
        </div>
      </div>
    </LoadingProvider>
  );
}
